export default __webpack_public_path__ + "static/media/searchIcon.a8146458.svg";